import React, { useLayoutEffect, useRef, useState } from 'react';
import { arrangeMasonry } from '../lib/masonry';

const MasonryGallery = ({ images, label, testId, maxColumns = 3 }) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    const element = ref.current;
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  const count = Math.min(maxColumns, width >= 1280 ? 3 : width >= 560 ? 2 : 1);
  const gap = width >= 560 ? 16 : 12;
  const columns = count === 1 ? [images] : arrangeMasonry(images, count, width, gap);
  return (
    <div ref={ref} data-testid={testId} className="grid items-start" style={{ gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`, gap }}>
      {columns.map((column, index) => (
        <div key={index} className="flex min-w-0 flex-col" style={{ gap }}>
          {column.map(image => (
            <figure key={image.src} className="m-0 overflow-hidden bg-beige">
              <img src={image.src} width={image.width} height={image.height} alt={image.alt || label} loading="lazy" decoding="async" className="block w-full h-auto" />
            </figure>
          ))}
        </div>
      ))}
    </div>
  );
};

export default MasonryGallery;
